import { Grid, makeStyles, Typography } from "@material-ui/core";
import React from "react";

interface TitleWithIconProps {
  title: React.ReactNode;
  children?: JSX.Element;
  variant: "h3" | "h4" | "h5";
}

const useStyles = makeStyles((theme) => ({
  main: {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "baseline",
    gap: theme.spacing(1) + "px",
  },
}));

const TitleWithIcon: React.FC<TitleWithIconProps> = ({ title, children, variant }) => {
  const classes = useStyles();

  return (
    <Grid container={true} direction="row" alignItems="center" spacing={1} className={classes.main}>
      {children}
      <Typography variant={variant}>{title}</Typography>
    </Grid>
  );
};

export default TitleWithIcon;
